class QuickViewDrawer extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('close', () => this.querySelector('quick-view')?.closeQuickView());
    }
  }
  customElements.define('quick-view-drawer', QuickViewDrawer);
  
  class QuickViewButton extends HTMLElement {
    constructor() {
      super();

      this.quickButton = this.querySelector('.quick') || this.closest('.quick');
      this.cardExtras = this.quickButton?.closest('.card__extras');
    }

    connectedCallback() {
      this._onClick = (event) => {
        if (
          event.target.closest('.card-quick-view') ||
          event.target.closest('.product-slide-caption')
        ) {
          event.preventDefault();
        }
  
        this.quickButton?.classList.add('loading');

  
        const drawer = document.querySelector('quick-view-drawer');
        if (drawer) {
          drawer.querySelector('quick-view').openProduct(
            this.dataset.productVariantUrl || this.dataset.productUrl,
            this.quickButton || this
          );

          document.dispatchEvent(
            new CustomEvent('quickview:open', {
              detail: {
                productUrl: this.dataset.productUrl
              }
            })
          );
        } else if (this.dataset.productUrl) {
          window.location = this.dataset.productUrl;
        }
      };
  
      this.addEventListener('click', this._onClick);

      if (this.cardExtras) {
        this._onFocus = () => {
          this.cardExtras.style.bottom = '8px';
        };
        this._onBlur = () => {
          this.cardExtras.style.bottom = '-54px';
        };
        this._onQuickViewOpen = () => {
          this.cardExtras.style.bottom = '-54px';
        };
  
        this.quickButton.addEventListener('focus', this._onFocus);
        this.quickButton.addEventListener('blur', this._onBlur);
        this.quickButton.addEventListener('quickview:open', this._onQuickViewOpen);
      }

      this._onQuickviewLoaded = () => {
        this.quickButton?.classList.remove('loading');
      };
  
      this._onQuickviewError = () => {
        this.quickButton?.classList.remove('loading');
      };
  
      document.addEventListener('quickview:loaded', this._onQuickviewLoaded);
      document.addEventListener('quickview:error', this._onQuickviewError);
    }

    disconnectedCallback() {
      if (this._onClick) {
        this.removeEventListener('click', this._onClick);
      }
  
      if (this.cardExtras) {
        if (this._onFocus) {
          this.quickButton.removeEventListener('focus', this._onFocus);
        }
        if (this._onBlur) {
          this.quickButton.removeEventListener('blur', this._onBlur);
        }
        if (this._onQuickViewOpen) {
          this.quickButton.removeEventListener('quickview:open', this._onQuickViewOpen);
        }
      }
  
      if (this._onQuickviewLoaded) {
        document.removeEventListener('quickview:loaded', this._onQuickviewLoaded);
      }
      if (this._onQuickviewError) {
        document.removeEventListener('quickview:error', this._onQuickviewError);
      }
    }
  }
  customElements.define('quick-view-button', QuickViewButton);
  
  class QuickView extends HTMLElement {
    connectedCallback() {
      this.overlay = document.querySelector('body > .overlay');
      this.content = this.querySelector('.quick-view__content');
      this.details = this.closest('details');
    }

    disconnectedCallback() {
      this.closeQuickView();
    }

    async openProduct(productUrl, opener) {
      this.session?.abort();
      const session = new AbortController();
      this.session = session;
      this.opener = opener;
      this.dataset.productUrl = productUrl;
      const options = { capture: true, signal: session.signal };
      const closeButtonSelector = '.popup-wrapper__quick-view > .scroll-area > .button-wrapper > .button-close';
      this.addEventListener('click', event => {
        if (event.target.closest(closeButtonSelector) || !event.target.closest('.popup-wrapper')) {
          event.preventDefault();
          this.closeQuickView();
        }
      }, options);
      this.overlay?.addEventListener('click', event => {
        // A size guide or other nested dialog can own the same backdrop.
        if (document.querySelector('body > .popup-wrapper.open, body > modal-dialog[open]')) return;
        event.stopImmediatePropagation();
        this.closeQuickView();
      }, options);
      document.addEventListener('keyup', event => {
        if (event.key !== 'Escape' || document.querySelector('body > .popup-wrapper.open, body > modal-dialog[open]')) return;
        event.stopImmediatePropagation();
        this.closeQuickView();
      }, options);

      this.details.open = true;
      document.body.classList.add('hidden', 'quick-view-open');
      document.body.classList.remove('quick-view-load');
      this.overlay?.classList.add('open');
      this.content.classList.remove('hide-cover');
      const loadingClose = document.createElement('button');
      loadingClose.type = 'button';
      loadingClose.className = 'button';
      loadingClose.textContent = document.querySelector('cart-drawer .drawer__close')?.getAttribute('aria-label') || 'Close';
      this.content.replaceChildren(loadingClose);
      loadingClose.focus({ preventScroll: true });

      try {
        const url = new URL(productUrl, location.href);
        url.searchParams.set('view', 'quick-view');
        const response = await fetch(url, { signal: session.signal });
        if (!response.ok) throw new Error('Quick view returned ' + response.status);
        const html = await response.text();
        if (session.signal.aborted) return;
        const product = new DOMParser().parseFromString(html, 'text/html')
          .querySelector('.quick-view__content.hide-cover');
        if (!product?.querySelector('.popup-wrapper__quick-view')) throw new Error('Quick view is unavailable');
        this.setInnerHTML(this.content, product.innerHTML);
        if (session.signal.aborted) return;
        const closeButton = this.content.querySelector(closeButtonSelector);
        if (closeButton) closeButton.setAttribute('aria-label', loadingClose.textContent);
        this.content.classList.add('hide-cover');
        document.body.classList.add('quick-view-load');
        trapFocus(this.content, closeButton || this.content, [], { preventScroll: true });
        window.Shopify?.PaymentButton?.init();
        document.dispatchEvent(new CustomEvent('quickview:loaded', { detail: { productUrl } }));
      } catch (error) {
        if (session.signal.aborted) return;
        console.error(error);
        this.closeQuickView();
        document.dispatchEvent(new CustomEvent('quickview:error', { detail: { productUrl } }));
      }
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;
  
      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    closeQuickView({ openingCart = false } = {}) {
      if (!this.session) return;
      this.session.abort();
      this.session = null;
      this.details.open = false;
      this.content.replaceChildren();
      this.content.classList.remove('hide-cover');
      document.body.classList.remove('quick-view-open', 'quick-view-load');
      this.opener?.classList.remove('loading');
      removeTrapFocus(!openingCart && this.opener?.isConnected ? this.opener : null, { preventScroll: true });
      if (!openingCart) {
        this.overlay?.classList.remove('open');
        document.body.classList.remove('hidden');
        document.dispatchEvent(new CustomEvent('body:visible'));
      }
      document.dispatchEvent(new CustomEvent('quickview:close'));
    }
  }
  customElements.define('quick-view', QuickView);
  